import { createBrowserRouter } from "react-router-dom";
import Layout from "../Componets/Layout";
import Dashboard from "../Pages/Dashboard";
import Reports from "../Pages/Reports";
import Quotes from "../Pages/Quotes";
import AddQuotes from "../Pages/Quotes/AddQuotes";
import QuotationPage from "../Pages/Quotes/AddQuotes/page";
import ViewReports from "../Pages/Reports/ViewReports";
import SuppliersForm from "../Pages/Suppliers/Suppliers/Form";
import SuppliersTable from "../Pages/Suppliers/Suppliers/Table";
import CustomersTable from "../Pages/Customers/Customers/Table";
import CustomersForms from "../Pages/Customers/Customers/Form";
import ContractorsTable from "../Pages/Contractors/Contractors/Table";
import ContractorsForm from "../Pages/Contractors/Contractors/Form";
import EmployeesForm from "../Pages/Employees/Employees/Form";
import EmployeesTable from "../Pages/Employees/Employees/Table";
import Home from "../Pages/Home";
import SignupForm from "../Pages/Signup/Form";
import SigninForm from "../Pages/Signin/Form";
import RolesForm from "../Pages/Employees/Roles/Form";
import RolesTable from "../Pages/Employees/Roles/Table";
import Page404 from "../Pages/Results/Page404";
import SettingsTable from "../Pages/Settings/Settings/Table";
import GeneralForm from "../Pages/Settings/General/Form";
import UsersTable from "../Pages/Settings/Users/Table";
import UsersForm from "../Pages/Settings/Users/Form";
import BranchesTable from "../Pages/Settings/Branches/Table";
import BranchesForm from "../Pages/Settings/Branches/Form";
import SettingRolesTable from "../Pages/Settings/Roles/Table";
import SettingRolesForm from "../Pages/Settings/Roles/Form";
import ExpensesTable from "../Pages/Expenses/Expenses/Table";
import ExpensesForm from "../Pages/Expenses/Expenses/Form";
import ExpensecategoriesForm from "../Pages/Expenses/Categories/Form";
import ExpensecategoriesTable from "../Pages/Expenses/Categories/Table";
import Boq from "../Pages/Quotes/Boq";
import AddboqForm from "../Pages/Quotes/Boq/form";
import BoqsForm from "../Pages/Sales/Boqs/Form";
import BoqsTable from "../Pages/Sales/Boqs/Table";
import QuotesTable from "../Pages/Sales/Quotes/Table";
import QuotesForm from "../Pages/Sales/Quotes/Form";
import InvoicesTable from "../Pages/Sales/Invoices/Table";
import InvoicesForm from "../Pages/Sales/Invoices/Form";
import BoqPage from "../Pages/Quotes/Boq/view";
import ProjectsTable from "../Pages/Projects/Projects/Table";
import ProjectsForm from "../Pages/Projects/Projects/Form";
import ProjectsjobsTable from "../Pages/Projects/Jobs/Table";
import ProjectsjobsForm from "../Pages/Projects/Jobs/Form";
import ProjectsTasksTable from "../Pages/Projects/Tasks/Table";
import ProjectsTasksForm from "../Pages/Projects/Tasks/Form";
import ProjectsTimesheetsForm from "../Pages/Projects/Timesheet/Form";
import ProjectsTimesheetsTable from "../Pages/Projects/Timesheet/Table";
import ProjectsIssuesTable from "../Pages/Projects/Issues/Table";
import ProjectsIssuesForm from "../Pages/Projects/Issues/Form";
import InventoryStockTable from "../Pages/Inventory/Stock/Table";
import InventoryStockForm from "../Pages/Inventory/Stock/Form";
import InventoryExpiryTable from "../Pages/Inventory/Expiry/Table";
import InventoryExpiryForm from "../Pages/Inventory/Expiry/Form";
import InventoryTransferTable from "../Pages/Inventory/Transfer/Table";
import InventoryTransferForm from "../Pages/Inventory/Transfer/Form";
import InventoryReceivedTable from "../Pages/Inventory/Received/Table";
import InventoryReceivedForm from "../Pages/Inventory/Received/Form";
import InventoryBatchForm from "../Pages/Inventory/Batch/Form";
import InventoryBatchTable from "../Pages/Inventory/Batch/Table";
import ProductsTable from "../Pages/Products/Products/Table";
import ProductsForm from "../Pages/Products/Products/Form";
import ProductUnitsTable from "../Pages/Products/Units/Table";
import ProductUnitsForm from "../Pages/Products/Units/Form";
import ProductCategoriesTable from "../Pages/Products/Categories/Table";
import ProductCategoriesForm from "../Pages/Products/Categories/Form";
import ProductBrandsTable from "../Pages/Products/Brands/Table";
import ProductBrandsForm from "../Pages/Products/Brands/Form";
import PurchasesOrderForm from "../Pages/Purchases/Order/Form";
import PurchaseView from "../Pages/Purchases/Order/View";
import PurchasesReceivedForm from "../Pages/Purchases/Received/Form";
import PurchasesReceivedTable from "../Pages/Purchases/Received/Table";
import PurchasesPaidForm from "../Pages/Purchases/Paid/Form";
import PurchasesReturnTable from "../Pages/Purchases/Return/Table";
import PurchasesReturnForm from "../Pages/Purchases/Return/Form";
import PurchasesSentTable from "../Pages/Purchases/Sent/Table";
import PurchasesSentForm from "../Pages/Purchases/Sent/Form";
import PurchasesRefundTable from "../Pages/Purchases/Refund/Table";
import PurchasesRefundForm from "../Pages/Purchases/Refund/Form";
import PurchasesPaidTable from "../Pages/Purchases/Paid/Table";
import PurchasesOrderTable from "../Pages/Purchases/Order/Table";
import InvoicePage from "../Pages/Sales/Invoices/View";

const router = createBrowserRouter([
  {
    path: "*",
    element: <Page404 />,
  },
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/signup",
    element: <SignupForm />,
  },
  {
    path: "/signin",
    element: <SigninForm />,
  },
  {
    path: "/app",
    element: <Layout />,
    children: [
      {
        path: "/app/dashboard",
        element: <Dashboard />,
      },

      //projects
      {
        path: "/app/projects",
        element: <ProjectsTable />,
      },
      {
        path: "/app/projects/add",
        element: <ProjectsForm />,
      },
      {
        path: "/app/projects/edit/:id",
        element: <ProjectsForm />,
      },

      {
        path: "/app/projects/jobs/:project",
        element: <ProjectsjobsTable />,
      },
      {
        path: "/app/projects/jobs/add/:project",
        element: <ProjectsjobsForm />,
      },
      {
        path: "/app/projects/jobs/edit/:project/:id",
        element: <ProjectsjobsForm />,
      },

      {
        path: "/app/projects/tasks/:project",
        element: <ProjectsTasksTable />,
      },
      {
        path: "/app/projects/tasks/add/:project",
        element: <ProjectsTasksForm />,
      },
      {
        path: "/app/projects/tasks/edit/:project/:id",
        element: <ProjectsTasksForm />,
      },

      {
        path: "/app/projects/timesheets/:project",
        element: <ProjectsTimesheetsTable />,
      },
      {
        path: "/app/projects/timesheets/add/:project",
        element: <ProjectsTimesheetsForm />,
      },
      {
        path: "/app/projects/timesheets/edit/:project/:id",
        element: <ProjectsTimesheetsForm />,
      },

      {
        path: "/app/projects/issues/:project",
        element: <ProjectsIssuesTable />,
      },
      {
        path: "/app/projects/issues/add/:project",
        element: <ProjectsIssuesForm />,
      },
      {
        path: "/app/projects/issues/edit/:project/:id",
        element: <ProjectsIssuesForm />,
      },

      // sales
      {
        path: "/app/sales",
        element: <InvoicesTable />,
      },
      {
        path: "/app/sales/add",
        element: <InvoicesForm />,
      },
      {
        path: "/app/sales/edit/:id",
        element: <InvoicesForm />,
      },
      {
        path: "/app/sales/invoices/view/:id",
        element: <InvoicePage />,
      },

      {
        path: "/app/sales/quotes",
        element: <QuotesTable />,
      },
      {
        path: "/app/sales/quotes/add",
        element: <QuotesForm />,
      },
      {
        path: "/app/sales/quotes/edit/:id",
        element: <QuotesForm />,
      },
      {
        path: "/app/sales/boqs",
        element: <BoqsTable />,
      },
      {
        path: "/app/sales/boqs/add",
        element: <BoqsForm />,
      },
      {
        path: "/app/sales/boqs/edit/:id",
        element: <BoqsForm />,
      },

      {
        path: "/app/products",
        element: <ProductsTable />,
      },
      {
        path: "/app/products/add",
        element: <ProductsForm />,
      },
      {
        path: "/app/products/edit/:id",
        element: <ProductsForm />,
      },
      {
        path: "/app/products/units",
        element: <ProductUnitsTable />,
      },
      {
        path: "/app/products/units/add",
        element: <ProductUnitsForm />,
      },
      {
        path: "/app/products/units/edit/:id",
        element: <ProductUnitsForm />,
      },
      {
        path: "/app/products/categories",
        element: <ProductCategoriesTable />,
      },
      {
        path: "/app/products/categories/add",
        element: <ProductCategoriesForm />,
      },
      {
        path: "/app/products/categories/edit/:id",
        element: <ProductCategoriesForm />,
      },
      {
        path: "/app/products/brands",
        element: <ProductBrandsTable />,
      },
      {
        path: "/app/products/brands/add",
        element: <ProductBrandsForm />,
      },
      {
        path: "/app/products/brands/edit/:id",
        element: <ProductBrandsForm />,
      },

      {
        path: "/app/inventory",
        element: <InventoryBatchTable />,
      },
      {
        path: "/app/inventory/add",
        element: <InventoryBatchForm />,
      },
      {
        path: "/app/inventory/edit/:id",
        element: <InventoryBatchForm />,
      },
      {
        path: "/app/inventory/stock",
        element: <InventoryStockTable />,
      },
      {
        path: "/app/inventory/stock/add",
        element: <InventoryStockForm />,
      },
      {
        path: "/app/inventory/expiry",
        element: <InventoryExpiryTable />,
      },
      {
        path: "/app/inventory/expiry/add",
        element: <InventoryExpiryForm />,
      },
      {
        path: "/app/inventory/transfer",
        element: <InventoryTransferTable />,
      },
      {
        path: "/app/inventory/transfer/add",
        element: <InventoryTransferForm />,
      },
      {
        path: "/app/inventory/received",
        element: <InventoryReceivedTable />,
      },
      {
        path: "/app/inventory/received/add",
        element: <InventoryReceivedForm />,
      },

      {
        path: "/app/employees",
        element: <EmployeesTable />,
      },
      {
        path: "/app/employees/add",
        element: <EmployeesForm />,
      },
      {
        path: "/app/employees/edit/:id",
        element: <EmployeesForm />,
      },
      {
        path: "/app/employees/roles",
        element: <RolesTable />,
      },
      {
        path: "/app/employees/roles/add",
        element: <RolesForm />,
      },
      {
        path: "/app/employees/roles/edit/:id",
        element: <RolesForm />,
      },

      {
        path: "/app/customers",
        element: <CustomersTable />,
      },
      {
        path: "/app/customers/add",
        element: <CustomersForms />,
      },
      {
        path: "/app/customers/edit/:id",
        element: <CustomersForms />,
      },
      {
        path: "/app/suppliers",
        element: <SuppliersTable />,
      },
      {
        path: "/app/suppliers/add",
        element: <SuppliersForm />,
      },
      {
        path: "/app/suppliers/edit/:id",
        element: <SuppliersForm />,
      },

      {
        path: "/app/quotes",
        element: <Quotes />,
      },
      {
        path: "/app/quotes/add",
        element: <AddQuotes />,
      },
      {
        path: "/app/quotes/boq",
        element: <Boq />,
      },
      {
        path: "/app/quotes/boq/add",
        element: <AddboqForm />,
      },

      {
        path: "/app/quotes/boq/view",
        element: <BoqPage />,
      },
      {
        path: "/app/quotes/view",
        element: <QuotationPage />,
      },

      {
        path: "/app/purchases",
        element: <PurchasesOrderTable />,
      },
      {
        path: "/app/purchases/add",
        element: <PurchasesOrderForm />,
      },

      {
        path: "/app/purchases/order",
        element: <PurchasesOrderTable />,
      },
      {
        path: "/app/purchases/orders/add",
        element: <PurchasesOrderForm />,
      },
      {
        path: "/app/purchases/orders/edit/:id",
        element: <PurchasesOrderForm />,
      },
      {
        path: "/app/purchases/orders/view/:id",
        element: <PurchaseView />,
      },

      {
        path: "/app/purchases/received",
        element: <PurchasesReceivedTable />,
      },
      {
        path: "/app/purchases/received/add",
        element: <PurchasesReceivedForm />,
      },
      {
        path: "/app/purchases/paid",
        element: <PurchasesPaidTable />,
      },
      {
        path: "/app/purchases/paid/add",
        element: <PurchasesPaidForm />,
      },
      {
        path: "/app/purchases/return",
        element: <PurchasesReturnTable />,
      },
      {
        path: "/app/purchases/return/add",
        element: <PurchasesReturnForm />,
      },
      {
        path: "/app/purchases/sent",
        element: <PurchasesSentTable />,
      },
      {
        path: "/app/purchases/sent/add",
        element: <PurchasesSentForm />,
      },
      {
        path: "/app/purchases/refund",
        element: <PurchasesRefundTable />,
      },
      {
        path: "/app/purchases/refund/add",
        element: <PurchasesRefundForm />,
      },

      {
        path: "/app/expenses",
        element: <ExpensesTable />,
      },
      {
        path: "/app/expenses/add",
        element: <ExpensesForm />,
      },
      {
        path: "/app/expenses/edit/:id",
        element: <ExpensesForm />,
      },
      {
        path: "/app/expenses/categories",
        element: <ExpensecategoriesTable />,
      },
      {
        path: "/app/expenses/categories/add",
        element: <ExpensecategoriesForm />,
      },
      {
        path: "/app/expenses/categories/edit/:id",
        element: <ExpensecategoriesForm />,
      },
      {
        path: "/app/contractors",
        element: <ContractorsTable />,
      },
      {
        path: "/app/contractors/add",
        element: <ContractorsForm />,
      },
      {
        path: "/app/contractors/edit/:id",
        element: <ContractorsForm />,
      },

      {
        path: "/app/reports",
        element: <Reports />,
      },
      {
        path: "/app/reports/projects",
        element: <ViewReports />,
      },
      {
        path: "/app/reports/inventory",
        element: <ViewReports />,
      },
      {
        path: "/app/reports/employees",
        element: <ViewReports />,
      },
      {
        path: "/app/reports/customers",
        element: <ViewReports />,
      },
      {
        path: "/app/reports/suppliers",
        element: <ViewReports />,
      },
      {
        path: "/app/reports/quotes",
        element: <ViewReports />,
      },
      {
        path: "/app/reports/sales",
        element: <ViewReports />,
      },
      {
        path: "/app/reports/purchases",
        element: <ViewReports />,
      },
      {
        path: "/app/reports/contractors",
        element: <ViewReports />,
      },

      {
        path: "/app/settings",
        element: <SettingsTable />,
      },
      {
        path: "/app/settings/general",
        element: <GeneralForm />,
      },
      {
        path: "/app/settings/users",
        element: <UsersTable />,
      },
      {
        path: "/app/settings/users/add",
        element: <UsersForm />,
      },
      {
        path: "/app/settings/branches",
        element: <BranchesTable />,
      },
      {
        path: "/app/settings/branches/add",
        element: <BranchesForm />,
      },
      {
        path: "/app/settings/branches/edit/:id",
        element: <BranchesForm />,
      },
      {
        path: "/app/settings/roles",
        element: <SettingRolesTable />,
      },
      {
        path: "/app/settings/roles/add",
        element: <SettingRolesForm />,
      },
    ],
  },
]);

export default router;
